import { Logger} from '../../interfaces/logger.interface';
//interface to interact with external logger object
interface External {

    //this method will return the instance of logger
    LogJSRequests: Function;
}

export class AFWLogger implements Logger{

    private externalRefafwLogger : any
    public loggerInitialized = false
    constructor() 
    {

        if (typeof window.external !== "undefined") {
            try
            {
                //get window's external element
                let external = (window.external as unknown as External);
                if(typeof external !== "undefined" && typeof external.LogJSRequests !== "undefined" )
                {
                    //get afw logger object
                    this.externalRefafwLogger = external
                    this.loggerInitialized = true;// set loggerInitialized flag to true
                    this.logInfo("AFWLogger", "Instance of logger is created.");
                }
            }
            catch(error)
            {
                console.log("error while creating AFW Logger " + error);
            }
        }
    }

    //log error
    public logError(source:string, message:string) 
    {
        this.externalRefafwLogger.LogJSRequests("Error",source, message);
    }

    //log info
    public logInfo(source:string, message:string) 
    {
        this.externalRefafwLogger.LogJSRequests("Debug",source, message);
    }

    //log warning
    public logWarning(source:string, message:string) 
    {
        this.externalRefafwLogger.LogJSRequests("Warning",source, message);
    }
}